var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 0,
    id: "new-contact-fields"
};
const _hoisted_3 = { class: "flex flex-col w-full" };
const _hoisted_4 = { class: "flex justify-between mb-1" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("label", { class: "n-form-item-label n-form-item-label--right-mark" }, [
    /*#__PURE__*/ _createTextVNode("Phone "),
    /*#__PURE__*/ _createElementVNode("label", { class: "text-danger" }, " *")
], -1);
const _hoisted_6 = { class: "flex flex-col w-full" };
const _hoisted_7 = { class: "flex justify-between mb-1" };
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("label", { class: "n-form-item-label n-form-item-label--right-mark" }, [
    /*#__PURE__*/ _createTextVNode("Email "),
    /*#__PURE__*/ _createElementVNode("label", { class: "text-danger" }, " *")
], -1);
import { searchContact } from '@/helper/SearchContact';
import { ContactServices } from '@/service/ContactService';
import { ConversationService } from '@/service/ConversationService';
import libphonenumber from 'google-libphonenumber';
import { formatPhoneNumber, populateEmail, populatePhone, validateEmail, validatePhone, } from '@/utils/validation';
import { MessageSquare01Icon, PlusIcon, HelpCircleIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIAlert, UIAvatar, UIDivider, UIForm, UIFormItem, UIInput, UIModal, UIModalContent, UIModalFooter, UIModalHeader, UISelect, UISpace, UITextMdMedium, UITextMdNormal, UITextXsMedium, UITooltip, } from '@gohighlevel/ghl-ui';
import { computed, inject, ref } from 'vue';
import { AttributionMediums, AttributionSource } from '../../helper/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalNewMessage',
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'sendNewConversation'],
    setup(__props, { emit }) {
        const props = __props;
        const route = inject('route');
        const store = inject('store');
        const user = inject('user');
        const show = computed(() => props.showModal);
        const showAlert = ref(false);
        const errorMessage = ref('');
        const root = ref();
        const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
        const formattedPhone = computed({
            get: function () {
                if (!props.showModal)
                    return '';
                try {
                    const parsedNumber = phoneUtil.parse(formValue.value.phone);
                    if (phoneUtil.getRegionCodeForNumber(parsedNumber) &&
                        phoneUtil.getRegionCodeForNumber(parsedNumber) !== countryCode.value) {
                        return phoneUtil.format(parsedNumber, libphonenumber.PhoneNumberFormat.INTERNATIONAL);
                    }
                    else if (phoneUtil.getRegionCodeForNumber(parsedNumber)) {
                        return phoneUtil.format(parsedNumber, libphonenumber.PhoneNumberFormat.NATIONAL);
                    }
                    return formValue.value.phone;
                }
                catch (err) {
                    return formValue.value.phone;
                }
            },
            set: function (phone) {
                let value = formatPhoneNumber(phone, countryCode.value);
                // this.$emit('input', value)
                formValue.value.phone = value;
            },
        });
        const formValue = ref({
            contact: null,
            firstName: null,
            lastName: null,
            phone: null,
            email: null,
        });
        const loading = ref(false);
        const contactLoading = ref(false);
        const searchQuery = ref('');
        const isNewContact = ref(false);
        const showOptions = ref(false);
        const rules = {
            contact: {
                required: true,
                validator(rule, value) {
                    if (!value) {
                        return new Error('Please select the contact');
                    }
                    return true;
                },
                trigger: ['input', 'blur'],
            },
            email: {
                validator(rule, value) {
                    if (!value && formValue.value.phone) {
                        return true;
                    }
                    else if (!value && !formValue.value.phone) {
                        return new Error('Please enter email or phone to continue.');
                    }
                    else if (value && !validateEmail(value)) {
                        return new Error('Please enter a valid email address');
                    }
                    return true;
                },
                trigger: ['input', 'blur'],
            },
            phone: {
                validator(rule, value) {
                    if (!value && formValue.value.email) {
                        return true;
                    }
                    else if (!value && !formValue.value.email) {
                        return new Error('Please enter email or phone to continue.');
                    }
                    else if (value && !validatePhone(value)) {
                        return new Error('Please enter a valid phone number.');
                    }
                    return true;
                },
                trigger: ['input', 'blur'],
            },
        };
        const contactOptions = ref([]);
        const selectedContact = ref({});
        const contactSelectRef = ref(null);
        const countryCode = computed(() => {
            let currentLocationId = route.params.location_id;
            if (currentLocationId) {
                const location = store.getters['locations/getById'](currentLocationId);
                //console.log(location)
                if (location && location.country) {
                    return location.country;
                }
            }
            const company = store.getters['company/get'];
            if (company && company.country) {
                return company.country;
            }
            return 'US';
        });
        function closeModal() {
            formValue.value = {
                contact: null,
                firstName: null,
                lastName: null,
                phone: null,
                email: null,
            };
            closeAlert();
            isNewContact.value = false;
            searchQuery.value = '';
            showOptions.value = false;
            emit('close');
        }
        let debouncer;
        function handleSearch(query) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!query.length || query.length < 3) {
                    contactOptions.value = [];
                    return;
                }
                contactLoading.value = true;
                searchQuery.value = query;
                formValue.value = {
                    contact: null,
                    firstName: null,
                    lastName: null,
                    phone: null,
                    email: null,
                };
                if (debouncer)
                    clearTimeout(debouncer);
                debouncer = setTimeout(() => sendSearchRequest(query), 300);
            });
        }
        function sendSearchRequest(query) {
            return __awaiter(this, void 0, void 0, function* () {
                const locationId = route.params.location_id;
                const response = yield searchContact(user, query, locationId, countryCode.value);
                contactOptions.value = response.contacts;
                showOptions.value = true;
                contactLoading.value = false;
            });
        }
        function updateSelectedContact(val) {
            return __awaiter(this, void 0, void 0, function* () {
                const selectedContactData = contactOptions.value.filter(option => option.value === val);
                if (selectedContactData && selectedContactData.length > 0) {
                    selectedContact.value = selectedContactData[0];
                    formValue.value.contact = `${selectedContactData[0].label}`;
                    formValue.value.email = selectedContactData[0].email;
                    formValue.value.phone = selectedContactData[0].phone;
                    formValue.value.firstName = selectedContactData[0].firstName;
                    formValue.value.lastName = selectedContactData[0].lastName;
                }
                isNewContact.value = false;
                showOptions.value = false;
            });
        }
        function setNewContactValue(val) {
            return __awaiter(this, void 0, void 0, function* () {
                showOptions.value = false;
                isNewContact.value = true;
                formValue.value.contact = searchQuery.value;
                if (populateEmail(searchQuery.value))
                    formValue.value.email = searchQuery.value;
                else if (populatePhone(searchQuery.value))
                    formValue.value.phone = formatPhoneNumber(searchQuery.value, countryCode.value);
                else if (!populateEmail(searchQuery.value) &&
                    !populatePhone(searchQuery.value)) {
                    formValue.value.firstName = searchQuery.value.split(' ')[0];
                    formValue.value.lastName = searchQuery.value.split(' ')[1];
                }
            });
        }
        function submit() {
            return __awaiter(this, void 0, void 0, function* () {
                root.value
                    .getForm()
                    .validate()
                    .then(() => __awaiter(this, void 0, void 0, function* () {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
                    try {
                        if (!formValue.value.email && !formValue.value.phone) {
                            showAlert.value = true;
                            errorMessage.value = 'Please enter email or phone to continue.';
                            loading.value = false;
                            return;
                        }
                        if (loading.value)
                            return;
                        loading.value = true;
                        let cont = selectedContact.value;
                        let conversationData;
                        const locationId = route.params.location_id;
                        if (cont && !cont.id) {
                            //save contact
                            const contactParams = {
                                firstName: (_a = formValue.value.firstName) !== null && _a !== void 0 ? _a : '',
                                lastName: (_b = formValue.value.lastName) !== null && _b !== void 0 ? _b : '',
                                locationId: locationId,
                                attributionSource: {
                                    medium: AttributionMediums.Conversation,
                                    mediumId: null,
                                    sessionSource: AttributionSource.Others,
                                },
                                internalSource: {
                                    type: 'new_message',
                                    id: user.id,
                                    userName: user.name,
                                },
                            };
                            if (formValue.value.email)
                                contactParams.email = formValue.value.email;
                            if (formValue.value.phone)
                                contactParams.phone = formValue.value.phone;
                            // console.log(contactParams)
                            cont = yield ContactServices.createContact(contactParams);
                            if (cont && cont.data.contact) {
                                conversationData = {
                                    contactId: cont.data.contact.id,
                                    deleted: false,
                                    locationId: locationId,
                                    isNew: true,
                                    email: (_c = formValue.value.email) !== null && _c !== void 0 ? _c : '',
                                    phone: (_d = formValue.value.phone) !== null && _d !== void 0 ? _d : '',
                                    firstName: (_e = formValue.value.firstName) !== null && _e !== void 0 ? _e : '',
                                    lastName: (_f = formValue.value.lastName) !== null && _f !== void 0 ? _f : '',
                                    type: formValue.value.email ? 2 : 1,
                                    id: 'new-contact-conversation',
                                    last_message_type: formValue.value.email ? 3 : 2,
                                };
                            }
                            else {
                                showAlert.value = true;
                                errorMessage.value = (_h = (_g = cont.response) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.message;
                                loading.value = false;
                            }
                            // await createNewConversation(cont.data.contact)
                        }
                        else if (cont && cont.id && !cont.conversationId) {
                            conversationData = {
                                contactId: cont.id,
                                deleted: false,
                                locationId: locationId,
                                isNew: true,
                                email: (_j = formValue.value.email) !== null && _j !== void 0 ? _j : '',
                                phone: (_k = formValue.value.phone) !== null && _k !== void 0 ? _k : '',
                                firstName: (_l = formValue.value.firstName) !== null && _l !== void 0 ? _l : '',
                                lastName: (_m = formValue.value.lastName) !== null && _m !== void 0 ? _m : '',
                                type: formValue.value.email ? 2 : 1,
                                id: 'new-contact-conversation',
                                last_message_type: formValue.value.email ? 3 : 2,
                            };
                        }
                        else {
                            conversationData = yield fetchConversation(cont.conversationId);
                            if (!conversationData)
                                conversationData = {
                                    contactId: cont.id,
                                    deleted: false,
                                    locationId: locationId,
                                    isNew: true,
                                    email: (_o = formValue.value.email) !== null && _o !== void 0 ? _o : '',
                                    phone: (_p = formValue.value.phone) !== null && _p !== void 0 ? _p : '',
                                    firstName: (_q = formValue.value.firstName) !== null && _q !== void 0 ? _q : '',
                                    lastName: (_r = formValue.value.lastName) !== null && _r !== void 0 ? _r : '',
                                    type: formValue.value.email ? 2 : 1,
                                    id: 'new-contact-conversation',
                                    last_message_type: formValue.value.email ? 3 : 2,
                                };
                        }
                        if (conversationData) {
                            closeModal();
                            emit('sendNewConversation', conversationData);
                        }
                        loading.value = false;
                    }
                    catch (error) {
                        console.log(error);
                        showAlert.value = true;
                        errorMessage.value = (_t = (_s = error.response) === null || _s === void 0 ? void 0 : _s.data) === null || _t === void 0 ? void 0 : _t.message;
                        loading.value = false;
                    }
                }))
                    .catch(() => {
                    // do nothing
                });
            });
        }
        function createNewConversation(contact) {
            return __awaiter(this, void 0, void 0, function* () {
                const locationId = route.params.location_id;
                const data = {
                    locationId,
                    contactId: contact.id,
                };
                const response = yield ConversationService.create(data);
                if (response && response.data)
                    return response.data.conversation;
                throw Error('Something went wrong, please try again');
            });
        }
        function fetchConversation(conversationId) {
            return __awaiter(this, void 0, void 0, function* () {
                const response = yield ConversationService.get(conversationId).catch(err => err);
                if (response && response.data)
                    return response.data;
                else if (response && response.response.status == 400)
                    return;
                else
                    return response;
                //  throw Error('Something went wrong, please try again')
            });
        }
        function closeAlert() {
            errorMessage.value = '';
            showAlert.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), { show: show.value }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "conversations-new-message-modal-header",
                        title: "Create new message",
                        icon: _unref(MessageSquare01Icon),
                        description: "",
                        onClose: closeModal
                    }, null, 8, ["icon"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: "Continue",
                        negativeText: "Cancel",
                        onPositiveClick: submit,
                        onNegativeClick: closeModal,
                        id: "conversations-new-message-modal-footer",
                        loading: loading.value
                    }, null, 8, ["loading"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), {
                        id: "conversations-new-message-modal-content",
                        class: "pb-0"
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(UIForm), {
                                ref_key: "root",
                                ref: root,
                                model: formValue.value,
                                rules: rules,
                                id: "conversations-new-message-modal-form"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(UIFormItem), {
                                        label: "Select Contact",
                                        path: "contact"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(UISelect), {
                                                id: "conversations-new-message-modal-form-select-contact",
                                                value: formValue.value.contact,
                                                "onUpdate:value": [
                                                    _cache[0] || (_cache[0] = ($event) => ((formValue.value.contact) = $event)),
                                                    updateSelectedContact
                                                ],
                                                placeholder: "Select name, email or phone",
                                                options: contactOptions.value,
                                                filterable: "",
                                                loading: contactLoading.value,
                                                type: formValue.value.contact ? 'avatar' : null,
                                                clearable: "",
                                                ref_key: "contactSelectRef",
                                                ref: contactSelectRef,
                                                remote: "",
                                                onSearch: handleSearch,
                                                show: showOptions.value
                                            }, {
                                                action: _withCtx(() => [
                                                    (searchQuery.value.length > 0 &&
                                                        contactOptions.value.length === 0 &&
                                                        contactLoading.value === false)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                                            _createVNode(_unref(UITextXsMedium), { class: "text-muted" }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(" No matching result for `" + _toDisplayString(searchQuery.value) + "`", 1)
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createElementVNode("div", {
                                                                class: "flex mt-3 cursor-pointer",
                                                                style: { "color": "#004eeb" },
                                                                onClick: setNewContactValue
                                                            }, [
                                                                _createVNode(_unref(UIAvatar), {
                                                                    size: 24,
                                                                    style: { "background": "#d1e0ff" },
                                                                    class: "mr-1"
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createVNode(_unref(PlusIcon), {
                                                                            style: { "color": "#004eeb" },
                                                                            class: "w-5 h-5"
                                                                        })
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_unref(UITextMdMedium), { class: "mr-1" }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(" Add Contact ")
                                                                    ]),
                                                                    _: 1
                                                                }),
                                                                _createVNode(_unref(UITextMdNormal), null, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(searchQuery.value), 1)
                                                                    ]),
                                                                    _: 1
                                                                })
                                                            ])
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _: 1
                                            }, 8, ["value", "options", "loading", "type", "show"])
                                        ]),
                                        _: 1
                                    }),
                                    (isNewContact.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                            _createVNode(_unref(UIDivider)),
                                            _createVNode(_unref(UITextMdMedium), { class: "mb-3" }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode("New contact details")
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_unref(UISpace), { justify: 'space-between' }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(UIFormItem), { label: "First name" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                modelValue: formValue.value.firstName,
                                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formValue.value.firstName) = $event)),
                                                                id: "conversations-new-message-modal-form-input-firstName"
                                                            }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(UIFormItem), { label: "Last name" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UIInput), {
                                                                modelValue: formValue.value.lastName,
                                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formValue.value.lastName) = $event)),
                                                                id: "conversations-new-message-modal-form-input-lastName"
                                                            }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }),
                                            _createVNode(_unref(UISpace), { justify: 'space-between' }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: "Phone",
                                                        path: "phone",
                                                        "show-label": false
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_3, [
                                                                _createElementVNode("div", _hoisted_4, [
                                                                    _hoisted_5,
                                                                    _createVNode(_unref(UITooltip), { id: "new-message-phone-tooltip" }, {
                                                                        trigger: _withCtx(() => [
                                                                            _createVNode(_unref(HelpCircleIcon), { class: "w-5 h-5" })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(" In case of Phone number , enter in this format `country code and number` eg: +919123xxxxxx. ")
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _createVNode(_unref(UIInput), {
                                                                    modelValue: formattedPhone.value,
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((formattedPhone).value = $event)),
                                                                    id: "conversations-new-message-modal-form-input-phone"
                                                                }, null, 8, ["modelValue"])
                                                            ])
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_unref(UIFormItem), {
                                                        label: "Email",
                                                        path: "email",
                                                        "show-label": false
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_6, [
                                                                _createElementVNode("div", _hoisted_7, [
                                                                    _hoisted_8,
                                                                    _createVNode(_unref(UITooltip), { id: "new-message-email-tooltip" }, {
                                                                        trigger: _withCtx(() => [
                                                                            _createVNode(_unref(HelpCircleIcon), { class: "w-5 h-5" })
                                                                        ]),
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(" In case of Email , enter in this format abc@xyz.com ")
                                                                        ]),
                                                                        _: 1
                                                                    })
                                                                ]),
                                                                _createVNode(_unref(UIInput), {
                                                                    modelValue: formValue.value.email,
                                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((formValue.value.email) = $event)),
                                                                    id: "conversations-new-message-modal-form-input-email"
                                                                }, null, 8, ["modelValue"])
                                                            ])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]))
                                        : _createCommentVNode("", true),
                                    (showAlert.value)
                                        ? (_openBlock(), _createBlock(_unref(UIAlert), {
                                            key: 1,
                                            type: "error",
                                            onClose: closeAlert,
                                            id: "conversations-new-message-error-message"
                                        }, {
                                            title: _withCtx(() => [
                                                _createTextVNode("Error")
                                            ]),
                                            content: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(errorMessage.value), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["model"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["show"]));
        };
    }
});
